import type { HelpFile } from '../../types/help'
import { ApprovalPolicyDetailTestIds } from '../../../testids/ApprovalPolicyDetailTestIds'

export const approvalPolicyDetailHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyDetailTestIds.approvalPolicyDetailPage]:
      'Detail page for an approval policy — defines under which conditions an approval is required and which approver chain runs when those conditions match.',
    [ApprovalPolicyDetailTestIds.cardPolicyDetails]:
      'General metadata of the approval policy: name, description, type, owner, and audit fields.',
    [ApprovalPolicyDetailTestIds.cardTitlePolicyConditions]:
      'Conditions that determine when this policy applies. All conditions must match for the policy to be selected for an incoming request.',
    [ApprovalPolicyDetailTestIds.cardTitlePolicySteps]:
      'Ordered list of approval steps that run once this policy matches. Each step has its own resolver and strategy.',
    [ApprovalPolicyDetailTestIds.badgePolicyType]:
      'Type of approval policy — for example access request, restriction rule violation, or rehire decision.',
    [ApprovalPolicyDetailTestIds.btnEdit]:
      'Edit this approval policy: change conditions, steps, or metadata.',
    [ApprovalPolicyDetailTestIds.btnDelete]:
      'Permanently delete this approval policy — this action cannot be undone and will fail if the policy is currently in use.',
    [ApprovalPolicyDetailTestIds.colField]:
      'Request field whose value the condition compares against (for example access profile, target system, or party type).',
    [ApprovalPolicyDetailTestIds.colOperator]:
      'Comparison operator used by the condition (equals, in, starts-with, ...).',
    [ApprovalPolicyDetailTestIds.colValue]:
      'Value that the request field must match for the condition to fire.',
    [ApprovalPolicyDetailTestIds.colStepOrder]:
      'Position of the approval step within the chain — steps execute in ascending order.',
    [ApprovalPolicyDetailTestIds.colResolverType]:
      'How the approver(s) for this step are resolved — fixed identity, role, manager-of-requester, owner-of-target, etc.',
    [ApprovalPolicyDetailTestIds.colResolverParam]:
      'Parameter consumed by the resolver — for example the role name or fixed identity reference.',
    [ApprovalPolicyDetailTestIds.colApprovalStrategy]:
      'How approver decisions are aggregated within the step — single approver, all-required, or any-of.',
    [ApprovalPolicyDetailTestIds.colRequired]:
      'Whether this step is mandatory or can be skipped when no approver is resolved.',
  },
}
